var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"supplierPage"}},[_c('img',{attrs:{"src":require("../../assets/admin/images/iran.png"),"id":"iranImage","alt":""}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }